export const loadScript = (url, callback, id = "") => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        if (callback) {
          callback()
        }
      }
    };
  } else if (callback) {
    script.onload = callback;
  }

  script.src = url;
  script.id = id;
  document.getElementsByTagName("head")[0].appendChild(script);
};

/**
 * @param url {string}
 * @param id {string}
 * @returns promise
 * */
export const loadScriptPromise = (url, id) => {
  // Capture the caller before the asynchronous resource event loses its stack.
  const loadError = new Error('Failed to load script');
  return new Promise(function (resolve, reject) {
    if (id && document.getElementById(id)) {
      return resolve()
    }
    let s;
    s = document.createElement('script');
    s.src = url;
    s.id = id;
    s.onload = resolve;
    s.onerror = (event) => {
      loadError.name = 'ScriptLoadError';
      loadError.code = 'SCRIPT_LOAD_FAILED';
      loadError.resourceEvent = event;
      reject(loadError);
    };
    document.body.appendChild(s);
  });
};
